/* EF Lab presentation layer for product.fireplace-orderform only.
   Move existing DOM nodes; never clone controls, select options, change required
   flags, price data, native variants, or submit/checkout handlers. */
(function () {
  'use strict';

  function init() {
    var page = document.querySelector('.ef-lab-fireplace-page');
    var root = page && page.querySelector('#efOf');
    if (!root || root.dataset.efLabPurchase === 'ready') return;
    var total = root.querySelector('#efOfTotal');
    var atc = root.querySelector('#efOfAtc');
    var express = root.querySelector('#efOfExpressCheckout');
    if (!total || !atc || !express) return;

    var keys = ['screen', 'blower', 'remote', 'liner', 'front', 'media', 'logset', 'vent_kit', 'lighting', 'heat_mgmt'];
    var fields = keys.map(function (key) {
      var detail = root.querySelector('#efOfCd_' + key);
      var field = detail && detail.closest('.ef-of__field');
      return field && field.parentElement === root ? { field: field, detail: detail } : null;
    }).filter(Boolean);

    function disclosure(title, hint, className) {
      var box = document.createElement('details');
      box.className = 'ef-lab-fireplace-disclosure ' + className;
      var summary = document.createElement('summary');
      var heading = document.createElement('strong');
      heading.textContent = title;
      summary.appendChild(heading);
      if (hint) {
        var sub = document.createElement('span');
        sub.textContent = hint;
        summary.appendChild(sub);
      }
      box.appendChild(summary);
      return box;
    }

    if (fields.length) {
      var requiredHost = document.createElement('div');
      requiredHost.className = 'ef-lab-fireplace-required';
      var extras = disclosure('Accessories & installation options', 'Explore finishing touches, controls and installation accessories', 'ef-lab-fireplace-extras');
      var optionalHost = document.createElement('div');
      optionalHost.className = 'ef-lab-fireplace-extra-fields';
      extras.appendChild(optionalHost);
      root.insertBefore(requiredHost, fields[0].field);
      root.insertBefore(extras, fields[0].field);

      function putInOrder(host, entries) {
        entries.forEach(function (entry, index) {
          if (host.children[index] !== entry.field) host.insertBefore(entry.field, host.children[index] || null);
        });
      }
      function reconcile() {
        /* The existing engine can promote a paid accessory to required after its
           lazy data arrives. Such fields must never stay behind a closed panel,
           even once selected. Read the engine's flag, never infer it from price. */
        var required = fields.filter(function (entry) { return entry.detail.dataset.required === 'true'; });
        var optional = fields.filter(function (entry) { return entry.detail.dataset.required !== 'true'; });
        putInOrder(requiredHost, required);
        putInOrder(optionalHost, optional);
        var visible = function (entry) { return !entry.field.hidden && entry.field.style.display !== 'none'; };
        requiredHost.hidden = !required.some(visible);
        extras.hidden = !optional.some(visible);
      }
      reconcile();
      var observer = new MutationObserver(reconcile);
      fields.forEach(function (entry) {
        observer.observe(entry.detail, { attributes: true, attributeFilter: ['data-required'] });
        observer.observe(entry.field, { attributes: true, attributeFilter: ['style', 'hidden'] });
      });
    }

    // Optional notes and help follow the real purchase controls. Their existing
    // nodes, ids and event handlers remain inside the same configurator root.
    var notes = root.querySelector('.ef-of__field--photo');
    if (notes && notes.parentElement === root) {
      var notesBox = disclosure('Notes & saved configuration', 'Add project notes or save this selection', 'ef-lab-fireplace-notes');
      root.appendChild(notesBox);
      notesBox.appendChild(notes);
    }
    var guide = root.querySelector('#efOfGuideBtn');
    if (guide && guide.parentElement === root) root.appendChild(guide);
    var intro = root.querySelector('.ef-of__intro-title');
    if (intro) intro.textContent = 'Choose your fireplace options';
    var introNote = root.querySelector('.ef-of__head--intro .ef-of__price-sub');
    if (introNote) introNote.textContent = 'Choose the look and features you want for your fireplace.';
    root.dataset.efLabPurchase = 'ready';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
